import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Layout, useMedia } from '../../components/Boneyard';
import { greyA100, darkBlack } from '../../theme/theme/colors';
import { useTranslations } from '../../graphql/components/ApplicationQueryProvider';
import { PAYPAL_BANNER } from '../../../automationHooks.json';
import Markdown from '../../components/Markdown';

const Image = styled.img`
  width: 152px;
  height: 43px;
  object-fit: contain;
  margin: 0 16.8px 0 0;
`;

const PaypalBannerText = styled.div`
  color: ${darkBlack};
  text-align: center;
  font-size: ${props =>
    props.mq.lte('sm') ? props.theme.toRem(18) : props.theme.toRem(26)};
  font-weight: 600;
`;

const propTypes = {
  logo: PropTypes.object,
  disabled: PropTypes.bool,
};

const PaypalBanner = ({ logo, disabled }) => {
  const translations = useTranslations();
  const mq = useMedia();

  const { paypalInformationHtml } = translations.paypalBanner;

  if (disabled) {
    return null;
  }

  return (
    <Layout.FullWidth>
      <Layout.Strip color={greyA100}>
        <Box
          d={mq.gt('sm') ? 'flex' : undefined}
          pt={3}
          pb={3}
          alignItems="center"
          w={'100%'}
          automationHook={PAYPAL_BANNER.hook}
        >
          <Box
            d={mq.lte('sm') ? 'flex' : undefined}
            justifyContent={mq.lte('sm') ? 'center' : undefined}
          >
            <Image src={logo?.path} alt={logo?.alt} />
          </Box>
          <Box ml={4}>
            <PaypalBannerText mq={mq}>
              <Markdown source={paypalInformationHtml} />
            </PaypalBannerText>
          </Box>
        </Box>
      </Layout.Strip>
    </Layout.FullWidth>
  );
};

PaypalBanner.propTypes = propTypes;
export default PaypalBanner;
